import { useMediaQuery } from '@mui/material';
import { Link } from 'react-router-dom';

import { HubDevice } from 'api/traps/DevicesWareHouse/types';
import { MediaBreakpoints } from 'hooks/Screen/useScreenSize';

interface Props {
  data: HubDevice;
  isAll: boolean;
}

const HubDeviceExpandable: React.FC<Props> = ({ data, isAll }) => {
  const mobile = useMediaQuery(MediaBreakpoints.mobile);
  const largeDesktop = useMediaQuery(MediaBreakpoints.largeDesktop);
  const tablet = useMediaQuery(MediaBreakpoints.tablet);

  return isAll ? (
    <div className="d-flex w-100 justify-content-around border-bottom">
      {largeDesktop && (
        <div className="d-flex flex-column my-2">
          <div>
            <span className="me-1 fs-14 fw-bold">Is used</span>
          </div>
          <div>
            {data.is_used ? (
              <div className="my-2 d-flex justify-content-start">
                <div className="text-truncate" style={{ maxWidth: '120px' }}>
                  {' '}
                  <span
                    className="badge bg-dark-subtle text-dark p-2"
                    style={{ display: 'block', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}
                  >
                    {data.is_used.site_name}
                  </span>
                </div>
              </div>
            ) : (
              <div>
                <span className="badge bg-danger-subtle text-danger p-2">Not in use yet</span>
              </div>
            )}
          </div>
        </div>
      )}

      {tablet && (
        <div className="d-flex flex-column my-2">
          <div>
            <span className="me-1 fs-14 fw-bold">Is used</span>
          </div>
          <div className="my-2 d-flex justify-content-start">
            {data.is_used ? (
              <Link to="#" className="link-cell-item text-truncate">
                <div className="icon">
                  <i className="ri-external-link-fill icon rounded-pill fs-14 me-1" />
                </div>

                <div className="text w-100 d-flex align-items-center justify-content-center">
                  <span>{data.is_used.site_name || 'None'}</span>
                </div>
              </Link>
            ) : (
              <Link to="#" className="link-cell-item text-truncate">
                <div className="icon">
                  <i className="ri-external-link-fill icon rounded-pill fs-14 me-1" />
                </div>

                <div className="text w-100 d-flex align-items-center justify-content-center">
                  <span>None</span>
                </div>
              </Link>
            )}
          </div>
        </div>
      )}

      {mobile && (
        <div className="d-flex flex-column my-2">
          <div>
            <span className="me-1 fs-14 fw-bold">Actions</span>
          </div>
          <div className="d-flex  my-2 justify-content-center">
            <i className="ri-delete-bin-6-fill" />
          </div>
        </div>
      )}
    </div>
  ) : (
    <div className="d-flex w-100 justify-content-around border-bottom">
      <div className="d-flex flex-column my-2">
        <div>
          <span className="me-1 fs-14 fw-bold">Model</span>
        </div>
        <div>{data.model_trap_type}</div>
      </div>
    </div>
  );
};

export default HubDeviceExpandable;
